const envUrlPrefix = 'https://api.gridedge.dev/';

export const environment = {
  LOGIN_PRODUCT_LINK: "https://gridedge.site/",
  LOA_SUBMISSION_TOKEN: envUrlPrefix + 'v1/loa/token',
  LOA_SIGN: envUrlPrefix + 'v1/loa/sign',
  PRIVACY_POLICY: "https://gridedge.ai/privacy"
};
